<template>
<div >
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>

    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">
        <v-row dense>
          <v-col class="pa-0 ma-0">
            <div class="text-center" ><label class="font-weight-black blue--text text--darken-4 title">Select a unit below</label></div>
            <v-list>
              <v-list-item-group
                active-class="blue--text"
              >
                <template v-for="(item, index) in values">
                  <v-list-item :key="index">
                    <!-- eslint-disable-next-line -->
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-content>
                        <v-list-item-title class="subtitle-1 font-weight-bold blue--text text--darken-4" v-text="item.group"></v-list-item-title>
                        </v-list-item-content>
                      <v-list-item-action>
                        <v-list-item-action-text >
                          <v-btn depressed outlined text icon medium color="blue darken-4" :to="`/frolist/${item.group}`">
                              <v-icon >
                                mdi-chevron-right
                              </v-icon>
                          </v-btn>
                        </v-list-item-action-text>

                      </v-list-item-action>
                    </template>
                  </v-list-item>

                  <v-divider
                  :key="item.group + index"
                  ></v-divider>
                </template>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </v-container>
    </div>
      
    <!-- Begin - Loading Data Modal -->
    <v-dialog
      v-model="isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Loading Data...
          <v-progress-linear
            indeterminate
            rounded
            color="white"
            class="mb-0"
            height="20px"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End - Loading Data Modal -->
  </div>
</template>

<script>


export default {
  name: 'FROList',
  components: {

  },
  data () {
    return {
      isLoading: false,
      values: []
    }
  },
  mounted() {
    this.getData();
    this.setBackButtonVisibility(true);
    this.setHomeButtonVisibility(true);

    this.getData(this.typeId);

  },
  methods: {
    getData() {

    this.isLoading = true;

    var obj = {
      wing: this.selWing
    }

    this.$https.post(this.$vars.BaseUrl + this.$vars.GetFROListGroupsRoute, obj, this.$vars.config)
      .then(response => {
        //console.log(response);
        this.httpResponse = response;
        this.values = response.data;
        //this.setAircraftList(response.data);
        this.isLoading = false;
      })
      .catch(e => {
        console.log(e);
        this.isLoading = false;
      });
    },
    toProperCase(str) {
      str = str.toLowerCase().split(' ');
      for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
      }
      return str.join(' ');
    }
  }
}
</script>

<style scoped>
  .topHeader {
    height:20px
  }
</style>
